import React, { useState } from 'react';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';

import { translate } from '../Services/translation';
import { ModalStyles } from '../constants';
import CloseButton from './CloseButton';

export default function SizeGuide() {
    const sizeGuideText = useSelector((state) => state.product.sizeGuide);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    return (
        <>
            {sizeGuideText && (
                <button className="size-guide__trigger" onClick={() => setModalIsOpen(true)}>
                    <i className="size-guide__icon"></i>
                    <span>{translate('product.sizeguide')}</span>
                </button>
            )}

            {sizeGuideText && (
                <Modal
                    isOpen={modalIsOpen}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                    onRequestClose={() => setModalIsOpen(false)}
                    closeTimeout1MS={150}
                    style={ModalStyles}
                >
                    <div className="modal-close">
                        <CloseButton title="Stäng" onClick={() => setModalIsOpen(false)} />
                    </div>
                    <div className="modal-body" dangerouslySetInnerHTML={{ __html: sizeGuideText }}></div>
                </Modal>
            )}
        </>
    );
}
